// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__FNJ1S","arrow":"Breadcrumbs_arrow__RTiDD","path":"Breadcrumbs_path__bspGr","clickAbleLink":"Breadcrumbs_clickAbleLink__CBmSL"};